<template>
    <q-page padding>
        <div class="about-container">
            <h2>Djembé!</h2>
            <table>
                <tr>
                    <td>
                        <p>
                            <br />
                            <br />
                            Cette version de <em>Djembé!</em> est le résultat de mon envie de pouvoir
                            écrire des partitions de djembé qui soient lisibles par le plus grand nombre.
                            <br />
                            Ensuite, l'envie de partager ces partitions m'a conduit à intégrer ces partitions
                            dans un site web accessible à tous.
                            <br />
                            Toujours dans cette démarche de partage, j'ai voulu offrir à d'autres la possibilité
                            d'utiliser mon outil, d'où l'adjonction d'un système d'autentification, principalement 
                            pour éviter la polution générée par les robots.
                            <br />
                            Enfin, et parce que certains sont plus <em>auditifs</em> que <em>visuels</em>, j'ai 
                            rajouté la possibilité d'entendre certaines phrases.
                        </p>
                        <p>
                            Ce site est en constante évolution ; il n'est pas parfait, loin de là, mais j'ai la volonté
                            d'en étendre les possibilités et l'ergonomie au fil du temps. Si une idée géniale vous vient, 
                            n'hésitez pas à m'en faire part par email à pierre[at]pierrevn.be : je ne promets cependant 
                            rien d'autre que de lire votre email avec attention.
                        </p>
                        <p>
                            Bonne découverte et bonne lecture!
                        </p>
                    </td>
                    <td>
                        <img src="@/assets/djembefolla.png" style="height:20em; width:auto;" />
                    </td>
                </tr>
            </table>
            <div class="text-left">
                <h4>Mises à jour</h4>
                <ul>
                    <li>
                        <strong>03-Nov-2020</strong>
                        <ul>
                            <li>Bug fix: les préférences sont maintenant aussi accessibles aux invités (panneau latéral droit, cliquer sur <em>INVITÉ</em>).</li>
                        </ul>
                    </li>
                    <li>
                        <strong>26-Oct-2020</strong>
                        <ul>
                            <li>Possibilité d'écouter les dunums (mais demande cependant une syntaxe spécifique)'</li>
                        </ul>
                    </li>
                    <li>
                        <strong>25-Oct-2020</strong>
                        <ul>
                            <li>Possibilité de changer la vitesse d'audition (paramétrage dans "Invité &gt; Mes préférences")</li>
                            <li>Possibilité de faire jouer un appel en début d'audition (paramétrage dans "Invité &gt; Mes préférences")</li>
                            <li>Tous les sons de djembé sont maintenant implémentés et audibles</li>
                            <li>La page "A propos" (cette page-ci) liste maintenant les mises-à-jour successives.</li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div class="text-left">
                <h4>Restrictions et bugs connus</h4>
                <ul>
            
                    <li>L'impression ne fonctionne correctement que dans Google Chrome.</li>
                    <li>Le module de sons dans son ensemble est une fonctionalité au stade expérimental. Le temps n'est pas toujours bien respecté. Rejouer résoud souvent ce problème.</li>
                    <li>Il n'est pas possible de spécifier un formatage couleurs au milieu des notes.</li>
                    <li>La représentation des sons de douns en batterie n'est pas encore possible ; il faut utiliser une autre notation moins concise.</li>
                    <li>L'application ne fonctionne pas sous Internet Explorer.</li>
                    <li>L'application n'est pas optimisée pour smartphones.</li>
                    <li>Les rythmes sont joués sans tenir compte de l'anacrouse.</li>
                </ul>
            </div>
        </div>
    </q-page>
</template>

<script>
export default {
    name: 'PageAbout'
}
</script>

<style lang="less">
.about-container {
    text-align:center;
    max-width:960px;
    // overflow: scroll;
    margin-left: calc((100vw - 960px) / 2);
}
</style>